import type { ReactNode } from 'react'
import { MantineProvider as _MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { theme } from '@/shared/lib/mantine'
import '@mantine/core/styles.css'
import '@mantine/carousel/styles.css'
import '@mantine/notifications/styles.css'
import '@/shared/ui/style/reset.css'
import '@/shared/ui/style/variables.css'

interface MantineProviderProps {
  children: ReactNode
}

export function MantineProvider({ children }: MantineProviderProps) {
  return (
    <_MantineProvider
      theme={theme}
      defaultColorScheme="light"
    >
      <Notifications />
      {children}
    </_MantineProvider>
  )
}
